import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { fitmentTimeReportFiltersSelector } from '../../store/selectors/reportsSelectors';
import { fitmentTimeReportsOrderingSelector } from '../../store/selectors/coreOrderingSelectors';
import { getFitmentTimeReportOrderingThunk } from '../../store/thunks/core/coreOrderingThunks';
import { FitmentTimeReportOrdering } from '../enum/ReportTableOrders';
import { setFitmentTimeFilters } from '../../store/slices/reportsSlice';
import { initPaging } from '../../core/types/coreTypes';

export const useFitmentTimeReportDefaultOrdering = (shouldFetch = true) => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(fitmentTimeReportFiltersSelector);
  const ordering = useAppSelector(fitmentTimeReportsOrderingSelector);
  const [defaultOrder, setDefaultOrder] = useState<number | null>(null);

  useEffect(() => {
    !ordering.length && shouldFetch && dispatch(getFitmentTimeReportOrderingThunk());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!filters.order?.field) {
      const defaultOrdering = ordering.find((el) => el.label === FitmentTimeReportOrdering.CreationDate)?.value;
      if (defaultOrdering) {
        setDefaultOrder(defaultOrdering);
        dispatch(setFitmentTimeFilters({ ...filters, order: { field: defaultOrdering, isAsc: false } }));
      }
    }
    // eslint-disable-next-line
  }, [ordering]);

  return {
    ...initPaging,
    order: defaultOrder ? { field: defaultOrder, isAsc: false } : filters.order,
  };
};
